import React from 'react';

const CarouselSettingsModal = ({ isOpen, onClose, onChange, props, onSave }) => {

  const handleSave = async () => {
    await onSave();
    onClose();
    window.location.reload();
  };

  console.log(props.interval,"props.interval")

  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2>Banner Settings</h2>
        <label>
          Banner Time (Sec):
          <select
            value={props.interval}
            onChange={(e) => onChange("interval", parseInt(e.target.value))}
            style={{ ...styles.input, maxHeight: "50px", overflowY: "auto" }}
          >
            {[...Array(29)].map((_, index) => {
              const value = index + 2; // starts at 2
              return (
                <option key={value} value={value}>
                  {value}
                </option>
              );
            })}
          </select>

        </label>
        <label>
          Animation Type:
          <select
            value={props.animationType}
            onChange={(e) => onChange("animationType", e.target.value)}
            style={styles.input}
          >
            <option value="fade">Fade</option>
            <option value="slide">Slide</option>
            <option value="zoom">Zoom</option>
            <option value="flip">Flip</option>
            <option value="drop">Drop</option>
            <option value="push">Push</option>
          </select>
        </label>
        <div style={styles.buttonRow}>
          <button onClick={onClose} style={styles.button}>Cancel</button>
          <button onClick={handleSave} style={styles.buttonPrimary}>Save</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
    alignItems: 'center', justifyContent: 'center', zIndex: 1000,
  },
  modal: {
    background: '#fff', padding: '20px', borderRadius: '8px',
    width: '300px', boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
  },
  input: {
    width: '100%', padding: '8px', margin: '8px 0',
    borderRadius: '4px', border: '1px solid #ccc',
  },
  buttonRow: {
    display: 'flex', justifyContent: 'flex-end', gap: '10px',
  },
  button: {
    padding: '8px 12px', background: '#ccc', border: 'none',
    borderRadius: '4px', cursor: 'pointer',
  },
  buttonPrimary: {
    padding: '8px 12px', background: '#007bff', color: '#fff',
    border: 'none', borderRadius: '4px', cursor: 'pointer',
  },
};

export default CarouselSettingsModal;
